import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface QualityAcknowledgementProps {
  acknowledgeIssues: boolean;
  onAcknowledgeChange: (checked: boolean) => void;
  score: number;
}

export const QualityAcknowledgement = ({
  acknowledgeIssues,
  onAcknowledgeChange,
  score,
}: QualityAcknowledgementProps) => {
  return (
    <div className="flex items-center justify-between py-2">
      <div className="flex items-center gap-2">
        <Checkbox
          id="acknowledge"
          checked={acknowledgeIssues}
          onCheckedChange={(checked) => onAcknowledgeChange(checked as boolean)}
          className="border-gray-300"
        />
        <Label htmlFor="acknowledge" className="text-sm text-gray-600">
          I acknowledge the quality issues and want to proceed anyway
        </Label>
      </div>
      <div className="bg-[#F1F0FB] text-navy border border-navy/10 px-3 py-1 rounded-md text-sm font-medium shadow-sm">
        Data Quality: {score}%
      </div>
    </div>
  );
};